import React from 'react';
import Button from 'commonComponents/Button/Button';
import HeadersWithContentAndImage from 'commonComponents/sections/HeadersWithContentAndImage/HeadersWithContentAndImage';
import ListsAndImage from 'commonComponents/ListsAndImage/ListsAndImage';
import { howItWorksSectionImages } from '../images';
import { TextBlock } from 'commonComponents/common';
import styles from './HowItWorksSection.module.scss';

const HowItWorksSection = ({ content, summary, button, link }) => {
  const { title, subtitle, text } = content;

  summary.photo = howItWorksSectionImages[1];
  button.link = link;
  const advantagesSectionProps = {
    ...summary,
    photoPosition: 'start',
    additionalClasses: styles.ListAndImage
  };

  const textContent = <TextBlock text={ text } />;
  const additionalContent = (
    <>
      <ListsAndImage { ...advantagesSectionProps } />
      <Button { ...button } />
    </>
  );
  const sectionProps = { title, subtitle, textContent, additionalContent };

  return (
    <HeadersWithContentAndImage
      { ...sectionProps }
      anchor='how-it-works'
      image={ howItWorksSectionImages[0] }
      additionalClass="normalText"
    />
  );
};

export default HowItWorksSection;
